import { fetchWithAuth } from "../utils/fetchWithAuth";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8080";

export async function askQuestion({ restaurant, user, table, question }) {
    const url = new URL(`/${restaurant}/gethelp/${user}`, BASE_URL);
    url.searchParams.set("question", question);
    url.searchParams.set("table", table);

    const res = await fetchWithAuth(url.toString(), { method: "GET" });

    if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
    }

    const data = await res.json();
    return {
        answer: data.answer,
        preparedOrder: data.preparedOrder || null
    };
}
